"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'accountGrade.form.title.edit': 'Il tuo piano',
    'accountGrade.form.title.add': 'Il tuo piano',
    'accountGrade.form.back': 'Indietro',
    'accountGrade.form.name.label': 'Nome',
    'accountGrade.form.name.placeholder': 'Nome del pacchetto prezzo',
    'accountGrade.form.description.label': 'Descrizione',
    'accountGrade.form.description.placeholder': 'Descrizione del pacchetto prezzo',
    'accountGrade.form.price.label': 'Prezzo Mensile',
    'accountGrade.form.price.placeholder': 'Prezzo mensile (in USD)',
    'accountGrade.form.price.monthly.help': 'Prezzo abbonamento mensile in USD',
    'accountGrade.form.yearlyPrice.placeholder': 'Prezzo annuale (in USD)',
    'accountGrade.form.yearlyPrice.help': 'Prezzo abbonamento annuale in USD (solitamente scontato)',
    'accountGrade.form.creditsPerMonth.placeholder': 'Numero di crediti dati al mese',
    'accountGrade.form.creditsPerMonth.help': 'I crediti vengono aggiunti automaticamente agli account utente ogni mese',
    'accountGrade.form.active.label': 'Attivo',
    'accountGrade.form.active.description': 'Rendi disponibile questo pacchetto prezzo',
    'accountGrade.form.order.label': 'Ordine',
    'accountGrade.form.order.placeholder': 'Ordine di visualizzazione (opzionale)',
    'accountGrade.form.submit.create': 'Crea Pacchetto Prezzo',
    'accountGrade.form.submit.update': 'Aggiorna Pacchetto Prezzo',
    'accountGrade.form.save': 'Salva Pacchetto Prezzo',
    'accountGrade.form.saving': 'Salvando...',
    'accountGrade.form.unlimited': 'Illimitato',
};
